<template>
  <div class="cockpit">
    <!-- this part here is only the beginning overlay of Aircraft Pic and Fake Counters -->
    <transition name="overlay">
      <div v-show="loading">
        <v-img
            cover
            height="100vh"
            width="100vw"
            class="loadingOverlay"
            :class="aircraftConfig.selected.toLowerCase()"
            :src="loadingPic"
        />
        <LoadingCards :counting="counting" class="loadingBar"/>
      </div>
    </transition>

    <!-- Here comes the Overlay screen -->
    <transition name="fade">
      <div v-if="screenOn" class="darker" @click="screenSwitch({value: false, procedure: null})"></div>
    </transition>
    <transition name="zoomer">
      <screen v-if="screenOn" @screenSwitch="screenSwitch" :procedures="procedures"/>
    </transition>

    <!-- Here starts the real Cockpit -->
    <transition name="zoomer">
      <slider
          v-if="sliderOn && !screenOn && this.teacher"
          class="slider-center"
          @sliderSwitch="sliderSwitch"
          @screen-switch="screenSwitch"
          @next-procedure="switchToNextProcedure"
          :teacher="teacher"
      />
    </transition>

    <transition name="slider-left-trans">
      <CockpitSlider
          key="1"
          v-if="sliderVisible(sliderLeft)"
          class="cockpit-slider"
          side="left"
          :action-type="sliderLeft"
      />
    </transition>
    <transition name="slider-right-trans">
      <CockpitSlider
          key="2"
          v-if="sliderVisible(sliderRight)"
          :action-type="sliderRight"
          class="cockpit-slider"
          side="right"
      />
    </transition>
    <Panorama @loadingDone="loadingDone" @screenSwitch="screenSwitch"/>
    <HeaderOverlay style="position: fixed; top:0; left: 0" @screenSwitch="screenSwitch"/>
    <Infospots v-if="teacher && teacher.getSteps()" :teacher="teacher"/>
  </div>
</template>

<script>
import * as THREE from "three";

import LoadingCards from "@/components/LoadingCards.vue";
import Panorama from "@/components/Panorama.vue";
import CockpitSlider from "@/components/SliderCockpit.vue";
import Screen from "@/components/Screen.vue";
import Slider from "@/components/Slider.vue";
import HeaderOverlay from "../components/HeaderOverlay";
import {aircraftConfig, LufthansaColors, settings} from "../config";
import Lat, {initLAT, LATEventBus} from "../modules/LAT/LAT_main";
import Vue from "vue";
import {createMarker} from "../modules/LAT/panorama";
import {procedureTeacher} from "../modules/ProcedureTeacher";
import Infospots from "../components/Infospots";
import {setupFlappyBird, startGame} from "../modules/bird/flappybirdgame";

export default {
  name: "cockpit",
  data: function () {
    return {
      loadingPic: "",
      loading: true,
      counting: true,
      screenOn: false,
      sliderOn: false,
      teacher: null
    };
  },
  created() {
    Vue.prototype.$LAT = initLAT(this.$route.params.aircraft);
    Vue.prototype.$colors = LufthansaColors;
    this.loadingPic = aircraftConfig.getAsset('cockpit_loading');
    this.$store.commit("SET_AIRCRAFT", this.$route.params.aircraft);
  },
  computed: {
    procedures() {
      return aircraftConfig.procedures;
    },
    sliderLeft() {
      return this.genSlider('left');
    },
    sliderRight() {
      return this.genSlider('right');
    },
    aircraftConfig(){
      return aircraftConfig;
    }
  },
  mounted() {
    // use loadingDone method for 3D stuff
    window.LAT = this.$LAT;
    window.THREE = THREE;
  },
  methods: {
    sliderVisible(sliderType){
      let visible = !this.loading && !this.screenOn;
      if(sliderType === 'poi'){
        visible = visible && this.teacher && this.teacher.isRunning() && this.teacher.mode !== 'exam';
      }
      return visible
    },
    genSlider(where) {
      return aircraftConfig.getConfig().slider[where];
    },
    screenSwitch({value, procedure}) {

      value = value === undefined ? !this.screenOn : value;
      if (procedure) {
        this.sliderOn = true;
        this.teacher = procedureTeacher.selectProcedure(procedure);
      }
      this.screenOn = value;
    },
    switchToNextProcedure(teacher) {
      this.teacher = teacher;
    },
    sliderSwitch(value) {
      this.sliderOn = !this.sliderOn;
    },

    startAppLogic() {
      Vue.$log.info('Start LAT App')
      this.loading = false;

      setTimeout(()=>this.$LAT.lookAtObject(new THREE.Vector3(5000, -1500, 0), 0), 100);
    },

    loadingDone: function () {
      this.counting = false;
      setTimeout(this.startAppLogic.bind(this), settings.DELAY_LOADING_SCREEN_COCKPIT);
    }
  },
  components: {
    Infospots,
    Panorama,
    LoadingCards,
    CockpitSlider,
    Screen,
    Slider,
    HeaderOverlay
  }
};
</script>

<style scoped>
.darker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  opacity: 0.5;
}


/* Animation for Fading Intro Aircraft Picture */
.overlay-leave-active {
  transition: opacity 3s ease-in-out, transform 3s ease-in;
}

.overlay-leave-to {
  opacity: 0;
  transform: scale(2);
}

/* Animation for Screen Background */
.fade-enter-active,
.fade-leave-active {
  transition: 0.5s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Animation for Screen */
.zoomer-enter-active,
.zoomer-leave-active {
  transition: 0.5s ease-in-out;
}

.zoomer-enter,
.zoomer-leave-to {
  transform: scale(0.8);
  transform: translateY(100%);
}

/* Animation for Sliders */
.slider-left-trans-enter-active,
.slider-left-trans-leave-active {
  transition: 1s ease-out;
}

.slider-left-trans-enter,
.slider-left-trans-leave-to {
  transform: translateX(-200px);
}

.slider-right-trans-enter-active,
.slider-right-trans-leave-active {
  transition: 1s ease-out;
}

.slider-right-trans-enter,
.slider-right-trans-leave-to {
  transform: translateX(200px);
}
</style>
